import React, { Component , Fragment } from "react";
import ScrollToTop from 'react-scroll-up';
import PageHelmet from "../component/common/Helmet";
import Footer from "../component/footer/Footer";
import { FiChevronUp} from "react-icons/fi";
import Header from "../component/header/Header";
import TabThree from "../elements/tab/TabThree";
import Breadcrumb from "../elements/common/Breadcrumb";

class DesignerPortfolio extends Component {
    render(){
        return(
            <Fragment>
                <PageHelmet pageTitle='Portfolio' />
                <Header logo="light" />
                <Breadcrumb title={'Portfolio'}   />

                    {/* Start Designer Portfolio  */}
                    <div className="designer-portfolio-area ptb--120 bg_color--1">
                        <div className="wrapper plr--70 plr_sm--30 plr_md--30">
                            <TabThree column="col-lg-4 col-md-6 col-sm-6 col-12" />
                        </div>
                    </div>
                    {/* End Designer Portfolio  */}

                    {/* Start Footer Style  */}
                    <Footer />
                    {/* End Footer Style  */}
                    
                    {/* Start Back To Top */}
                    <div className="backto-top">
                        <ScrollToTop showUnder={160}>
                            <FiChevronUp />
                        </ScrollToTop>
                    </div>
                    {/* End Back To Top */}

            </Fragment>
        )
    }
}

export default DesignerPortfolio
